import { api } from 'helpers/api'
import { useMutation } from 'react-query'

export const useRemoveBookmark = () => {
    return useMutation({
        mutationFn: api.bookmark.removeBookmark,
    })
}
